import { EntityType } from "@common/Common.types";
import { PreviewableDocument } from "@common/components/documentPreview/DocumentPreview.types";
import { isPreviewSupported } from "@common/components/documentPreview/DocumentPreview.hooks";
import { ObligationDocumentOption } from "../../../annualWheel/activityForm/ActivityContractSourceSection.types";

/** A link has no file on our side and an unsupported file type cannot be read, so neither can be analysed. */
export function isDocumentAnalysable(option: ObligationDocumentOption): boolean {
    return getDocumentBlockedTranslationKey(option) === undefined;
}

/**
 * Why a document cannot be analysed, as a translation key, or undefined when it can. A document the reader
 * has no access to stays in the list and says so: a document that simply vanished would read as a document
 * that does not exist.
 */
export function getDocumentBlockedTranslationKey(option: ObligationDocumentOption): string | undefined {
    if (!option.hasAccess) {
        return "obligationDocumentNoAccess";
    }

    if (option.isLink) {
        return "obligationDocumentIsLink";
    }

    if (!isPreviewSupported(option.fileName ?? "")) {
        return "obligationDocumentFileTypeNotSupported";
    }

    if (option.isTooLargeForAi) {
        return "textExtractionErrorFileTooLarge";
    }

    return undefined;
}

export function toPreviewableDocument(option: ObligationDocumentOption, contractId: string): PreviewableDocument {
    return {
        documentId: option.documentId,
        documentVersionId: option.documentVersionId,
        dataId: option.dataId,
        fileName: option.fileName,
        name: option.name,
        isTooLargeForAi: option.isTooLargeForAi,
        entityType: EntityType.Contract,
        entityId: contractId,
    };
}
